export default __webpack_public_path__ + "static/media/all-color.d3d99e26.png";